<script>
import Btn from '@components/button/btn-component.vue'
export default {
  components: { Btn },
  page: {
    title: 'Appointment Scheduled',
    meta: [{ name: 'description', content: 'The Appointment Scheduled page.' }],
  },
}
</script>

<template>
  <v-container>
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
        xl="4"
        :class="$style.paddingclss"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <h3 :class="$style.peerHeading">Appointment Scheduled</h3>
        <div :class="$style.text"
          >Your appointment has been added to your calendar. Click on the
          calendar event to edit or cancel.
        </div>

        <div class="mt-10">
          <router-link to="/safehaven/dashboard">
            <Btn :class="$style.fullbtn" title="Return to Dashboard"></Btn>
          </router-link>
        </div>
      </v-col>
      <v-col
        v-if="!notDesktop"
        class="pa-6"
        cols="12"
        sm="12"
        md="12"
        lg="8"
        xl="8"
      >
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.clickable {
  display: inline-flex;
  padding-left: 32px;
  text-align: left;
  vertical-align: middle;
}
.imgclss {
  margin-top: 6px !important;
}

.text {
  width: 80%;
  margin: 10px 0 0;
  font-size: 15px;
  line-height: 22.5px !important;
  color: #2c3a4b;
}
.title {
  font-size: 28px;
  font-weight: 400;
}
.fullWidthBtn {
  width: 80%;
  text-transform: unset !important;
}
.paddingclss {
  padding-left: 40px !important ;
}
.peerHeading {
  font-size: 28px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}
@media screen and (max-width: 1263px) {
  .paddingclss,
  .clickable {
    padding-left: 0 !important ;
  }
  .text {
    width: 100%;
  }
}
@media screen and (max-width: 960px) {
  .fullWidthBtn {
    width: 90%;
  }
}
@media screen and (max-width: 959px) {
  .paddingclss,
  .clickable {
    padding: 0 20px !important ;
  }
}
@media screen and (max-width: 599px) {
  .fullbtn {
    width: 100%;
  }
}
</style>
